import { render, staticRenderFns } from "./DaZuiE.vue?vue&type=template&id=472aa2bc&scoped=true&"
import script from "./DaZuiE.vue?vue&type=script&lang=js&"
export * from "./DaZuiE.vue?vue&type=script&lang=js&"
import style0 from "./DaZuiE.vue?vue&type=style&index=0&id=472aa2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472aa2bc",
  null
  
)

export default component.exports